<template>
  <div>
    <b-card header="Opciones de Filtro" class="card-filter">
      <b-btn class="filter-collapse" 
          variant="primary" 
          size="sm"
          @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
        <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
        <b-form>
          <b-form-group>
            <b-form-radio 
              v-model="filtro.filtroNumero" 
              name="filtroNumeroOption" 
              :value="Boolean(false)"
              stacked>Filtrar por período</b-form-radio>

            <b-collapse 
                id="filtroOpcionPeriodo" 
                class="mt-2" 
                v-model="showOpcionesPeriodo">

              <b-form-group
                label="Registro Desde"
                label-for="fechaDesde"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  id="fechaDesde" 
                  v-model="filtro.fechaDesde" 
                  type="date">
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Registro Hasta"
                label-for="fechaHasta"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  id="fechaHasta" 
                  v-model="filtro.fechaHasta" 
                  type="date">
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Cliente"
                label-for="cliente"
                :label-cols="labelCols"
                horizontal>
                <b-input-group>
                  <b-input-group-append 
                      class="filter-search-icons" 
                      @click="seleccionarCliente"
                      v-if="!filtro.filtroNumero">
                    <b-input-group-text>
                      <i :class="{ 'fa fa-search': !filtro.cliente,
                                    'fa fa-remove': filtro.cliente  }"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                  <b-form-input 
                    id="cliente"
                    :value="clienteNombre"
                    readonly
                    type="text"/>
                </b-input-group>
              </b-form-group>

              <b-form-group
                label="Contacto"
                label-for="contacto"
                :label-cols="labelCols"
                horizontal>
                <b-input-group>
                  <b-input-group-append 
                      class="filter-search-icons" 
                      @click="seleccionarContacto"
                      v-if="!filtro.filtroNumero">
                    <b-input-group-text>
                      <i :class="{ 'fa fa-search': !filtro.contacto,
                                    'fa fa-remove': filtro.contacto  }"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                  <b-form-input 
                    id="contacto"
                    :value="contactoNombre"
                    readonly
                    type="text"/>
                </b-input-group>
              </b-form-group>

              <app-usuario
                label="Usuario"
                description="Usuario que creó el Presupuesto Interno"
                :nombre="usuarioNombre"
                :lista="usuariosList"
                :label-cols="labelCols"
                labelOption="Todos los usuarios"
                :nullDisabled="false"
                :disabled="filtro.filtroNumero"
                @updated="usuarioActualizado">
              </app-usuario>  

              <b-form-group
                label="Acción"
                label-for="accion"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  id="numeroPO" 
                  v-model="filtro.accion" 
                  type="text"
                  :readonly="filtro.filtroNumero">
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Nro. PO"
                label-for="numeroPO"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  id="numeroPO" 
                  v-model="filtro.numeroPO" 
                  type="text"
                  :readonly="filtro.filtroNumero">
                </b-form-input>
              </b-form-group>

              <b-form-group
                v-if="opcionOrdenPresupuestosCertificadosFacturados"
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="sortByFechaCierreEstimado"
                    v-model="filtro.sortByFechaCierreEstimado"
                    :value= "Boolean(true)"
                    :unchecked-value= "Boolean(false)">
                    Ordenar presupuestos por fecha de cierre estimada (sólo Certificados/Facturados)
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="sortByDescending"
                    v-model="filtro.sortByDescending"
                    :value= "Boolean(true)"
                    :unchecked-value= "Boolean(false)">
                    Ordenar presupuestos en forma descendente
                </b-form-checkbox>
              </b-form-group>
            </b-collapse>

            <b-form-radio 
              v-model="filtro.filtroNumero" 
              name="filtroNumeroOption" 
              :value="Boolean(true)"
              stacked>Filtrar por número</b-form-radio>

            <b-collapse 
                id="filtroOpcionPresupuesto" 
                class="mt-2" 
                v-model="showOpcionesPresupuesto">              
              <b-form-group
                label="Nro. Presupuesto"
                label-for="numero"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  id="numero" 
                  v-model="filtro.numero" 
                  type="text"
                  :readonly="!filtro.filtroNumero">
                </b-form-input>
              </b-form-group>
            </b-collapse>
          </b-form-group>
        </b-form>

        <div class="footer">
          <b-button size="sm" variant="primary" class="footer-button"
            @click.prevent="filtrar">Filtrar</b-button>
          <b-button size="sm" variant="primary" class="footer-button" 
            @click.prevent="limpiarFiltro">Limpiar</b-button>
        </div>
      </b-collapse>
    </b-card>

    <b-modal ref="searchClienteModal" 
        title="Seleccionar Cliente"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-search-cliente
        :incluirInactivos="true"
        @clienteSeleccionado="clienteSeleccionado">
      </app-search-cliente>  
    </b-modal>

    <b-modal ref="searchContactoModal" 
        title="Seleccionar Contacto"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-search-contacto
        :cliente="filtro.cliente"
        @contactoSeleccionado="contactoSeleccionado">
      </app-search-contacto>  
    </b-modal>
  </div>
</template>

<script>
import SearchCliente from '../clientes/SearchList.vue';
import SearchContacto from '../clientescontactos/SearchList.vue';
import Usuario from '../shared/abmSelect.vue';
import moment from 'moment';

export default {
  components: {
    appSearchCliente: SearchCliente,
    appSearchContacto: SearchContacto,
    appUsuario: Usuario
  },
  props: {
    filtroNumero: {
      type: Boolean,
      default: false,
    },
    fechaDesde: {
      type: String,
      default: ''
    },
    fechaHasta: {
      type: String,
      default: ''
    },
    cliente: {
      type: Object,
      default: null
    },
    contacto: {
      type: Object,
      default: null
    },
    numero: {
      type: Number,
      default: 0
    },
    accion: {
      type: String,
      default: ''
    },
    numeroPO: {
      type: String,
      default: ''
    },
    usuario: {
      type: Object,
      default: null
    },
    sortByFechaCierreEstimado: {
      type: Boolean,
      default: false,
    },
    opcionOrdenPresupuestosCertificadosFacturados: {
      type: Boolean,
      default: true,
    },
    sortByDescending: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      filtro: {
        filtroNumero: false,
        fechaDesde: '',
        fechaHasta: '',
        cliente: null,
        contacto: null,
        numero: 0,
        accion: '',
        numeroPO: '',
        usuario: null,
        sortByDescending: false,
        sortByFechaCierreEstimado: false
      },
      showOpcionesFiltro: Boolean(false),
      labelCols: 2,
      usuarios: [],
      usuariosList: [],
      loadingUsuarios: false,

      showOpcionesPeriodo: true,
      showOpcionesPresupuesto: false,
    }
  },
  created() {
    this.filtro.filtroNumero = this.filtroNumero;
    this.filtro.fechaDesde = moment.utc(this.fechaDesde).format('YYYY-MM-DD');
    this.filtro.fechaHasta = moment.utc(this.fechaHasta).format('YYYY-MM-DD');
    this.filtro.cliente = this.cliente;
    this.filtro.contacto = this.contacto;
    this.filtro.numero = this.numero;
    this.filtro.accion = this.accion;
    this.filtro.numeroPO = this.numeroPO; 
    this.filtro.usuario = this.usuario;
    this.filtro.sortByDescending = this.sortByDescending;
    this.filtro.sortByFechaCierreEstimado = this.sortByFechaCierreEstimado;

    this.getDatosAdicionales();
  },
  computed: {
    'clienteNombre': function() {
      return this.filtro.cliente? this.filtro.cliente.nombre.trim() : '';
    },
    'contactoNombre': function() {
      return this.filtro.contacto? this.filtro.contacto.nombre.trim() : '';
    },
    'usuarioNombre': function() {
      return this.filtro.usuario? this.filtro.usuario.nombre.trim() : null;
    },
  },     
  methods: {
    getDatosAdicionales() {
      let params = {
        incluirInactivos: false
      }
      this.loadingUsuarios = true;
      this.$store.dispatch('usuarios/getList', params)
        .then(() => {
          this.usuarios = this.$store.getters['usuarios/list'];
          this.usuariosList = this.$store.getters['usuarios/selectList'];
          this.loadingUsuarios = false;
        })
    },
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
    limpiarFiltro() {
      this.filtro.cliente = null;
      this.filtro.contacto = null;
      this.filtro.numero = 0; 
      this.filtro.accion = '';
      this.filtro.numeroPO = '';
      this.filtro.usuario = null;
      this.filtro.sortByFechaCierreEstimado = false; 
    },
    seleccionarCliente() {
      if (this.filtro.cliente) {
        this.filtro.cliente = null;
      } else {
        this.$refs.searchClienteModal.show();
      }
    },
    clienteSeleccionado(cliente) {
      this.filtro.cliente = cliente;
      this.$refs.searchClienteModal.hide();
    },
    seleccionarContacto() {
      if (this.filtro.contacto) {
        this.filtro.contacto = null;
      } else {
        this.$refs.searchContactoModal.show();
      }
    },
    contactoSeleccionado(contacto) {
      this.filtro.contacto = contacto;
      this.$refs.searchContactoModal.hide();
    },
    usuarioActualizado(usuarioNombre) {
      if (!this.loadingUsuarios) {
        this.filtro.usuario= null;
        if (usuarioNombre) {
          this.filtro.usuario = this.getSelected(this.usuarios, usuarioNombre);
        }
      }
    },
  },
  watch: {
    'filtro.filtroNumero' : function(newVal, oldVal) {
      if (newVal) {
        this.showOpcionesPeriodo = false;
        this.showOpcionesPresupuesto = true;
      } else {
        this.showOpcionesPeriodo = true;
        this.showOpcionesPresupuesto = false;
      }
    },
  }    
}
</script>

<style>
</style>
